import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Button } from '../ui/button';

interface FilterButtonProps {
    activeCount: number;
    onClick: () => void;
    className?: string;
}

/** "Filters" / "Filters (3)" button — opens the advanced-filters drawer.
 * Shared across Assets/Licenses/Inventory so the control looks and behaves
 * identically everywhere. */
export const FilterButton: React.FC<FilterButtonProps> = ({ activeCount, onClick, className }) => (
    <Button
        type="button"
        variant="outline"
        // No height override — Button's default is h-11 below sm (≥44px touch
        // target) and h-9 from sm up, which is what desktop already showed.
        className={`gap-2 shrink-0 cursor-pointer ${className ?? ''}`}
        onClick={onClick}
        // The visible label collapses to an icon below sm, so the accessible
        // name has to be spelled out or the button announces as "(3)"/nothing.
        aria-label={activeCount > 0 ? `Filters, ${activeCount} active` : 'Filters'}
    >
        <SlidersHorizontal className="h-4 w-4" />
        <span className="hidden sm:inline">Filters</span>
        {activeCount > 0 && <span>({activeCount})</span>}
    </Button>
);
